import { Button, DatePicker, message, Modal, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../../Auth";
import imgSave from "../../../saveImg";
import dataDefault from './data';
import compute, { columns } from "./compute";
import request from "@/method/request";

const { MonthPicker } = DatePicker;
const totalIndex = [];


@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            data4_1: [],
        }
    }

    componentDidMount() {

        this.getData(this.state.date);
    }

    computeNum = (data) => {
        const { date, data4_1 } = this.state;
        data = compute(data, date, data4_1);
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true });
            let data = JSON.parse(JSON.stringify(dataDefault));
            const month = moment(date).format('M');
            const year = moment(date).format('YYYY');

            const x = await request(`/t4_1_4info?year=${year}&month=${month}`);

            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return a.sort - b.sort
                });
            }

            if (x.data.names.length) {
                data = data.map((v, i) => ({ ...v, name: x.data.names[i] }));
            }

            this.setState({ data4_1: x.data.data4_1 || [] }, () => {
                this.computeNum(data, true);
            });

        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {
        try {
            this.setState({ loadingSave: true });
            let date = this.state.date;
            if (!date) {
                message.error('请选择年份月份');
                let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                return
            }

            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = this.state.data.map((x, i) => ({ ...x, year, month, sort: i }));

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/t4_1_4add', headres);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        } catch (err) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '4.14', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} Monthly ADR By Room Type`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading } = this.state;

        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4"  >
                    <Row>4.1.4 Monthly ADR By Room Type</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str)
                            }}
                        />

                    </Row>
                    <Table
                        columns={columns(this.onChange, date, print)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_4"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-4/index.js